import React, {Component} from 'react';
import {observer} from 'mobx-react';
import './styles.scss';
import Button from '@material-ui/core/Button';
import AvatarIcon from "../AvatarIcon";
import Zoom from '../../assets/images/icon-zoom';
import {customEvent} from "../../utils/analyticsUtil";
import {actions, category, events} from "../../constants/enums";
import SvgIcon from "@material-ui/core/SvgIcon";

const avatarIconStyle = {
    width: '31px',
    height: '31px',
    minWidth: '31px',
    minHeight: '31px',
    border: '2px solid white'
};


@observer
class MeetingButton extends Component {

    handleClick = () => {
        const {teacher} = this.props;
        customEvent(events.CustomEvent, {category: category.Zoom, action: actions.StartAMeeting, label: teacher.id});
        // window.open(teacher.videoMeetingUrl, '_blank');
        if (this.props.onClick) {
            this.props.onClick();
        }
    }

    render() {
        const {teacher} = this.props;
        return (
            <Button className="zoom-modal-btn" onClick={this.handleClick}>
                <div className="zoom-button-wrapper">
                    <div className="zoom-button-avatar-name">
                        {<AvatarIcon iconStyle={avatarIconStyle} defaultIconStyle={avatarIconStyle} style={{background: 'none', border: '2px solid white'}}
                                     icon={teacher.avatar} useDefault={true} fullName={teacher.name} showOnlineStatus={true} isOnline={teacher.isOnline}/>}
                        <div className="zoom-button-name">
                            {teacher.name}
                        </div>
                    </div>
                    <div className="zoom-button-icon">
                        <SvgIcon viewBox="0 0 18 18">{Zoom}</SvgIcon>
                    </div>

                </div>
            </Button>
        );
    }
}

export default MeetingButton;
